import React from 'react';

import Hero from './Hero/Hero';
import WatchDemo from './WatchDemo/WatchDemo';
import Features from './Features/Features';
import Industry from './Industry/Industry';
import OurClients from './OurClients/OurClients';
import ClientsFeedback from './ClientsFeedback/ClientsFeedback';

const Home = () => {
  return (
    <>
      <Hero />
      <WatchDemo />
      <Features />
      <Industry />
      <OurClients />
      <ClientsFeedback />
    </>
  )
}

export default Home;